import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LogInContainer from './../../containers/LogIn/LogInContainer';
import { getUser, getError } from './../../reducers';
import * as Roles from './../../constants/roles';
import MainAdmin from './../../containers/admin/MainAdmin';
import MainResto from './../../containers/restaurant/MainResto';

const MainUser = ({ user, error }) => {
    return (
      <div className="MainUser">
        { error.state ?
            <LogInContainer />
            :
            user && user.roles ?
              user.roles.indexOf(Roles.ADMIN) > -1 ?
                <MainAdmin />
                :
                <MainResto />
              :
              <LogInContainer />
        }
      </div>
    );
}

MainUser.propTypes = {
  user: PropTypes.object,
  error: PropTypes.object,
};

const mapStateToProps = state => ({ 
  user:  getUser(state),
  error: getError(state),
});

export default connect(mapStateToProps, null)(MainUser);